import axiosInstance from "../api/axiosConfig";

export const addToCart = (data: any) => {
  return axiosInstance.post("/cart", data);
};

export const getCart = () => {
  return axiosInstance.get("/cart");
};

export const deleteCart = (id: string) => {
  return axiosInstance.delete(`/cart/${id}`);
};
